// @flow

import { v4 } from 'uuid';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import type { Node } from 'react';
import { analytics as ENUM_ANALYTICS } from 'Enum';
import { useStoreCode } from 'shared_services/redux/hooks/useStoreCode';
import { ListArtQuery } from 'shared_data/providers/queries/ListArtQuery';
import { ArtSlider } from 'shared_components/arts/slider/Slider';
import { ArtSliderSection } from 'shared_components/arts/containers/sections/Slider';
import LIST_ARTICLE_ARTS from 'shared_data/queries/articles/listArts.graphql';

const MAX_SLIDE_ITEMS = 15;
const preloaderId = v4();

type Props = {
  articleId: string | number,
  background?: ?string,
};

/**
 * RelatedArtworksSection
 *
 * @param {Props} props
 * @returns {Node}
 */
export function RelatedArtworksSection({ background = null, articleId }: Props): Node {
  const store = useStoreCode();
  const relatedArtworksTitle = (
    <FormattedMessage id="components.blog.relatedArtworks">
      {(label: string) => label}
    </FormattedMessage>
  );

  const SimilarArtworksPlaceholder = (
    <ArtSliderSection title={relatedArtworksTitle} {...(background ? { background } : null)}>
      <ArtSlider placeholder />
    </ArtSliderSection>
  );

  return (
    <ListArtQuery
      query={LIST_ARTICLE_ARTS}
      variables={{ articleId, store, items: MAX_SLIDE_ITEMS }}
      skip={!store}
      dataHandler={(data) => data.listArticleArts}
      preloadSubscriberId={preloaderId}
      placeholder={SimilarArtworksPlaceholder}
    >
      {(data) =>
        data && data.length > 0 ? (
          <ArtSliderSection title={relatedArtworksTitle} {...(background ? { background } : null)}>
            <ArtSlider
              items={data}
              tracking={{
                enabled: true,
                enableVisibility: true,
                enableClick: true,
                name: ENUM_ANALYTICS.list.name.ARTICLE_RELATED_ART,
              }}
            />
          </ArtSliderSection>
        ) : null
      }
    </ListArtQuery>
  );
}
